export default "__VITE_ASSET__CNZhIpNv__"